import * as types from '@/store/mutation-types'
import apolloClient from '@/api/apollo'

import FETCH_SHAPES from '@/graphql/queries/Routes/Shapes.graphql'
import FETCH_VEHICLES from '@/graphql/queries/Routes/Vehicles.graphql'
import CREATE_SHAPE from '@/graphql/mutations/Routes/CreateShape.graphql'
import UPDATE_SHAPE from '@/graphql/mutations/Routes/UpdateShape.graphql'
import REMOVE_SHAPE from '@/graphql/mutations/Routes/RemoveShape.graphql'

const module = {
  namespaced: true,
  state: {
    shapes: [],
    vehicles: []
  },
  mutations: {
    [types.SET_VEHICLES] (state, { vehicles }) {
      state.vehicles = vehicles
    },
    [types.SET_SHAPES] (state, { shapes }) {
      state.shapes = shapes
    }
  },
  actions: {
    async createShape ({ commit }, { shape }) {
      const result = await apolloClient.mutate({
        mutation: CREATE_SHAPE,
        variables: {
          shape
        }
      })
      const shapes = result.data.createRoute
      commit(types.SET_SHAPES, { shapes })
    },
    async fetchVehicles ({ commit }) {
      const result = await apolloClient.query({
        query: FETCH_VEHICLES
      })
      const vehicles = result.data.fetchVehicles
      commit(types.SET_VEHICLES, { vehicles })
    },
    async fetchShapes ({ commit }) {
      const result = await apolloClient.query({
        query: FETCH_SHAPES
      })
      const shapes = result.data.fetchRoutes
      commit(types.SET_SHAPES, { shapes })
    },
    async updateShape ({ commit }, { shapeId, shape }) {
      const result = await apolloClient.mutate({
        mutation: UPDATE_SHAPE,
        variables: {
          shapeId,
          shape
        }
      })
      const shapes = result.data.updateRoute
      commit(types.SET_SHAPES, { shapes })
    },
    async removeShape ({ commit }, { shapeId }) {
      const result = await apolloClient.mutate({
        mutation: REMOVE_SHAPE,
        variables: {
          shapeId
        }
      })
      const shapes = result.data.removeRoute
      commit(types.SET_SHAPES, { shapes })
    }
  }
}

export default module



// WEBPACK FOOTER //
// ./src/store/modules/routes/index.js